<div class="tracker">
    <h4>Submission tracker</h4>
    <div class="tracker__orders">
        <i *ngIf="!hasOrders()">You don't have any orders yet</i>
        <i class="mobile-hide" *ngIf="hasOrders()">You have <a routerLink="/orders"><strong>{{getOrdersCount()}}</strong></a> recent orders</i>
        <input type="image" src="/assets/img/arrow-previous.svg" class="button-icon" *ngIf="hasOrders()" [disabled]="!canMoveBackward()" [class.disabled]="!canMoveBackward()" (click)="moveBackward()">
        <i *ngIf="hasOrders()">Order #: <a routerLink=""><strong>{{orders[currentIndex].publicId}}</strong></a></i>
        <!--<div class="tracker__status" *ngIf="hasOrders()">
            <span [class.tracker__status--active]="getOrderStatusPosition() > 1">Submitted</span>
            <span [class.tracker__status--active]="getOrderStatusPosition() > 8">Graded</span>
            <span [class.tracker__status--active]="getOrderStatusPosition() > 17">On their way back</span>
        </div>-->

        <div class="tracker__status" *ngIf="hasOrders()">
            <span [class.tracker__status--active]="getOrderStatusPosition()==1 || getOrderStatusPosition()==13">Submitted</span>
            <span [class.tracker__status--active]="getOrderStatusPosition()==2 || getOrderStatusPosition()==3 ">Received</span>
            <span [class.tracker__status--active]="getOrderStatusPosition() ==4 || getOrderStatusPosition()==5
                      || getOrderStatusPosition()==6 || getOrderStatusPosition()==7 || getOrderStatusPosition()==8
                      || getOrderStatusPosition()==9 || getOrderStatusPosition()==12 || getOrderStatusPosition()==15
                      || getOrderStatusPosition()==16 || getOrderStatusPosition()==17 || getOrderStatusPosition()==18">
                Post-Grading Processing
            </span>
            <span [class.tracker__status--active]="getOrderStatusPosition() ==10 || getOrderStatusPosition()==11">On its way back</span>
        </div>


        <input type="image" src="/assets/img/arrow-next.svg" class="button-icon" *ngIf="hasOrders()" [disabled]="!canMoveForward()" [disabled]="!canMoveForward()" (click)="moveForward()">
    </div>
    <button class="button" (click)="startSubmission()">Start new submission</button>
</div>
